import { TranslationObject } from '@ngx-translate/core';

export class Source {
  titleShort: TranslationObject;
  title: TranslationObject;
  lastPublishedAt: Date;

  constructor(titleShort: TranslationObject, title: TranslationObject, lastPublishedAt: Date) {
    this.titleShort = titleShort;
    this.title = title;
    this.lastPublishedAt = lastPublishedAt;
  }
}
